<template>
  <div>
    <a-table
      style="margin-top: 20px"
      :dataSource="dataSource"
      :columns="columns"
      :pagination="false"
      :scroll="{ y: 430, x: 2000 }"
    >
    </a-table>
  </div>
</template>
<script>
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
export default {
  name: "VisualizationTable",
  props: {
    detail: {
      type: Object,
    },
  },
  setup(props) {
    const { t } = useI18n();

    const dataSource = ref();
    watch(props, () => {
      dataSource.value = props.detail?.data;
    });
    return {
      dataSource,
      columns: [
        {
          title: t("CPUusagerate"),
          dataIndex: "cpu_usage",
          key: "cpu_usage",
          align: "center",
        },
        {
          title: t("physicalusagerate"),
          dataIndex: "memory_usage",
          key: "memory_usage",
          align: "center",
        },
        {
          title: t("systemloadminute"),
          dataIndex: "system_load_1",
          key: "system_load_1",
          align: "center",
        },
        {
          title: t("systemloadfiveminute"),
          dataIndex: "system_load_5",
          key: "system_load_5",
          align: "center",
        },
        {
          title: t("systemloadquarterminute"),
          dataIndex: "system_load_15",
          key: "system_load_15",
          align: "center",
        },
        {
          title: t("diskwrite"),
          dataIndex: "disc_input",
          key: "disc_input",
          align: "center",
        },
        {
          title: t("diskread"),
          dataIndex: "disc_output",
          key: "disc_output",
          align: "center",
        },
        {
          title: t("networkwrite"),
          dataIndex: "network_input",
          key: "network_input",
          align: "center",
        },
        {
          title: t("networkread"),
          dataIndex: "network_output",
          key: "network_output",
          align: "center",
        },
        {
          title: t("time"),
          dataIndex: "xtime_data",
          key: "xtime_data",
          align: "center",
        },
      ],
    };
  },
};
</script>
<style scoped></style>
